import UserFieldsNameEnum from "../user/details/enum";
import { ApiConsoleUser } from "../user/list/types";

export function getProfileValues(profile?: ApiConsoleUser) {
  return {
    id: profile?.id,
    uiVersion: profile?.uiVersion,
    [UserFieldsNameEnum.FIRST_NAME]: profile?.firstName || "",
    [UserFieldsNameEnum.LAST_NAME]: profile?.lastName || "",
    [UserFieldsNameEnum.JOB_TITLE]: profile?.jobTitle || "",
    [UserFieldsNameEnum.LANGUAGE_TYPE]: profile?.languageType || ""
  };
}
